$(function(){
    var $btn_add = $('#operators_add');

    if($btn_add.length > 0) {
        $('#company_max_users').on('keyup, change', _.debounce(check_users_size , 500));
        $('#operators_list')
          .on('cocoon:after-insert', check_users_size)
          .on('cocoon:after-remove', check_users_size)
    }

    function check_users_size(){
        var size = $('#company_max_users').val(),
        actual = $('#operators_list .nested-fields:visible').length;

        if(actual >= size) $btn_add.addClass('disabled');
        else $btn_add.removeClass('disabled');
    }
});
